// extracted by mini-css-extract-plugin
export default {"DraftEditor":"Message_DraftEditor__ZoxD9"};